import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, Component, VNode } from 'vue';
import useMultiStateButton, {MultiStateButtonProps} from '@/services/composables/MultiStateButton';

export default /*#__PURE__*/_defineComponent({
  __name: 'MultiStateSVGButton',
  props: {
    modelValue: {},
    states: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "534ae166": (`${width.value}px`)
}))

const props = __props;
const emits = __emit;
const {
    state,
    toggleState
} = useMultiStateButton(props, emits);
const width = ref(0);
const resizeObserver = new ResizeObserver(entries=>{
    updateWidth(entries[entries.length-1].target)
});
function onSVGMounted(ev: VNode) {
    if(ev.el) {
        const el = ev.el as Element;
        resizeObserver.observe(el);
        updateWidth(el);
    }
}
function onSVGUnmounted(ev: VNode) {
    if(ev.el) resizeObserver.unobserve(ev.el as Element);
    else resizeObserver.disconnect();
}
function updateWidth(el: Element) {
    width.value = el.getBoundingClientRect().width;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "button-svg",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleState) && _unref(toggleState)(...args)))
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.states[_unref(state)]), {
      onVnodeMounted: onSVGMounted,
      onVnodeUnmounted: onSVGUnmounted
    }, null, 512))
  ]))
}
}

})